import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
} from '@angular/forms';

/**
 * Email validation check.
 *
 * @usageNotes
 * Can be used with reactive forms and with template-driven forms.
 *
 * @selector appEmail
 * @returns
 * ```javascript
 * { emailInvalid: true } | null
 * ```
 */
@Directive({
  selector: '[appEmail]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: EmailDirective,
      multi: true,
    },
  ],
})
export class EmailDirective {
  @Input('appEmail') email = '';

  constructor() {}

  validate(control: AbstractControl): ValidationErrors | null {
    return this.email ? emailValidator(control) : null;
  }
}

export const EMAIL_VALID_REGEX =
  /([a-zA-Z0-9_\-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})/;

/**
 * Email validation check.
 *
 * @returns
 * ```javascript
 * { emailInvalid: true } | null
 * ```
 */
export const emailValidator = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value;
  const valid = EMAIL_VALID_REGEX.test(value);

  return !valid ? { emailInvalid: true } : null;
};
